import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-recoge-creditos',
  templateUrl: './recoge-creditos.component.html',
  styleUrls: ['./recoge-creditos.component.css']
})
export class RecogeCreditosComponent implements OnInit {
  identity: any;
  creditos: any;
  checkCreditos: any;
  creditosRecoge = new Array();
  TRecoge = 0;
  pagaresRecogidos = new Array();
  datosCredito = new Array();
  total: number = 0;
  disabled: boolean = false
  check: any
  showError: any;
  error: string;

  constructor(
    private dialogRef: MatDialogRef<RecogeCreditosComponent>,
    private _userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.identity = JSON.parse(this._userService.GetsessionStorage('identity'));
    this.getCartera()
  }

  cerrar() {
    this.dialogRef.close({ data: false });
  }

  getCartera() {
    let date = new Date();
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let data = {
      codasociado: this.identity.CODASOCIADO,
      fhasta: year + '-' + (monthIndex + 1) + '-' + day,
      recoge: false,
      pse: false
    };
    this._userService.httpPost('cartera', data).subscribe(resp => {
      this.creditos = resp;
      console.log('creditos-recoge', this.creditos)
      for (let i = 0; i < this.creditos.length - 1; i++) {
        const chk = 'chk' + i;
        this.checkCreditos.push({ chk: i });
      }
    }, error => {
      console.log(JSON.parse(error));
    });
  }

  seleccionarCreditosRecoger($event, pagare, credito) {
    this.showError = false;
    if ($event.target.checked) {
      this.total = this.total + parseInt(credito.SALDOACTUAL)
      this.TRecoge = this.TRecoge + 1
      if (this.total <= parseInt(this.data.monto)) {
        this.disabled = false;
        this.pagaresRecogidos.push(pagare)
        this.datosCredito.push(credito)
      } else {
        this.disabled = true;
        this.showError = true;
        this.error = 'El valor de los créditos seleccionados es mayor al valor solicitado'
      }
    } else {
      this.disabled = false;
      this.TRecoge = this.TRecoge - 1
      this.total = this.total - parseInt(credito.SALDOACTUAL)
      this.removeItemFromArr(this.pagaresRecogidos, pagare)
      this.removeItemFromArr(this.datosCredito, credito)
    }
    console.log(this.TRecoge)
    console.log(this.pagaresRecogidos)
    console.log(this.datosCredito)
  }

  removeItemFromArr(arr, item) {
    const i = arr.indexOf(item);
    if (i !== -1) {
      arr.splice(i, 1);
    }
  }

  agregarCreditosSeleccionados(){
    this.dialogRef.close({ total: this.total, numCredRecoge: this.TRecoge, pagares: this.pagaresRecogidos, creditos: this.datosCredito })
  }

}
